import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from './common/components/page-not-found/page-not-found.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { AuthGuard } from './services/guards/auth-guard.guard';
import { Capacitor } from '@capacitor/core';
import { DeleteMyAccountPublicComponent } from './common/modules/delete-my-account-public/delete-my-account-public.component';

const routes: Routes = [
  {
    path: 'authentication',
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import('./modules/dashboard/dashboard.module').then(
        (m) => m.DashboardModule
      ),
    data: { breadcrumb: { label: 'Dashboard' } },
    canActivate: [AuthGuard],
  },
  {
    path: 'security',
    loadChildren: () =>
      import('./modules/security-pass/security-pass.module').then(
        (m) => m.SecurityPassModule
      ),
  },
  {
    path: 'emergency',
    loadChildren: () =>
      import('./modules/aumye-maps/aumye-maps.module').then(
        (m) => m.AumyeMapsModule
      ),
  },
  {
    path: 'delete-my-account',
    component: DeleteMyAccountPublicComponent,
  },
  {
    path: 'splash',
    // loadComponent: () => import('./splash-screen/splash-screen.component').then((m) => m.SplashScreenComponent),
    component: SplashScreenComponent,
  },
  {
    path: '',
    redirectTo: Capacitor.isNativePlatform()
      ? '/splash'
      : 'authentication/login',
    // redirectTo: 'authentication/login',
    pathMatch: 'full',
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
